import {
    C1AU_DOMAIN,
    C1UK_DOMAIN,
    CRUISE_AWAY_DOMAIN,
    DE_DOMAIN,
    NL_DOMAIN,
} from '../context/markets';
import { writeCookie } from './cookie';
import { validatePromoCode } from './validation';

export const PROMO_CODE_QUERY_PARAM = 'promocode';
export const PROMO_CODE_COOKIE = 'dl_promo_code';
export const PROMO_CODE_COOKIE_DAYS = 30;
const PROMO_CODE_MAX_AGE_MS = PROMO_CODE_COOKIE_DAYS * 24 * 60 * 60 * 1000;

// Registrable domain per market, used to scope the cookie (e.g. .cruise1st.co.uk).
const MARKET_DOMAINS = [DE_DOMAIN, NL_DOMAIN, CRUISE_AWAY_DOMAIN, C1AU_DOMAIN, C1UK_DOMAIN];

/**
 * Resolve the market's registrable domain from the host by matching against the known
 * market domains. This is robust for both apex hosts (cruise1st.co.uk) and prefixed hosts
 * (www./staging./testing./m-local.). Deriving it by label-counting instead would yield a
 * public suffix (.co.uk, .de) on apex hosts, which browsers reject — silently dropping the
 * cookie. Returns undefined for unknown hosts (e.g. localhost), which get a host-only cookie.
 */
const getRegistrableDomain = (hostname: string): string | undefined =>
    MARKET_DOMAINS.find((domain) => hostname.includes(domain));

/**
 * Reads `?promocode=` and, if the code is valid, remembers it for 30 days in the
 * `dl_promo_code` cookie, scoped to the link's market domain so it is not carried across
 * markets.
 */
export const checkPromocodeQuerystringParams = (
    url_string: string,
    ssr: boolean,
    response?: any,
) => {
    const url = new URL(url_string);
    const code = url.searchParams.get(PROMO_CODE_QUERY_PARAM);

    if (!code || !validatePromoCode(code)) {
        return;
    }

    if (ssr) {
        const registrableDomain = getRegistrableDomain(url.hostname);
        response.cookie(PROMO_CODE_COOKIE, code, {
            maxAge: PROMO_CODE_MAX_AGE_MS,
            path: '/',
            ...(registrableDomain ? { domain: `.${registrableDomain}` } : {}),
        });
    } else {
        // Client reuses the shared cookie helper. The edge redirects apex → www, so the
        // host always carries a subdomain label here and writeCookie's domain scoping
        // resolves to the same registrable domain as the SSR branch above.
        writeCookie(PROMO_CODE_COOKIE, code, PROMO_CODE_COOKIE_DAYS);
    }
};

export const stripPromocodeFromUrl = () => {
    const url = new URL(window.location.href);

    if (!url.searchParams.has(PROMO_CODE_QUERY_PARAM)) {
        return;
    }

    url.searchParams.delete(PROMO_CODE_QUERY_PARAM);

    window.history.replaceState(window.history.state, '', url.toString());
};
